<template>
<div>
    <div class="col">
        <div class="ibox sombra-light">
            <div class="ibox-title pb-3">
                <h5>
                    Pruebas
                </h5>
                <div class="ibox-tools">
                    <button class="btn btn-primary" @click="crear">Crear</button>
                </div>
            </div>
            <div class="ibox-content">
                <data-table :id="dt.id" :datos="dt.datos" :columnas="dt.columnas" :responsive="true" :font-size="12">

                </data-table>
            </div>
        </div>
    </div>
    <Modal ref="Modal" :canales="canales" :vouchers="vouchers" :tipo_citas="tipo_citas" :servicios="servicios" :establecimientos="establecimientos" @guardar="guardar"></Modal>
</div>
</template>

<script>
import Modal from './CrearModal'
import DataTable from '../DataTableLuis.vue';
export default {
    components: { Modal, DataTable },
    props: ['canales', 'vouchers', 'tipo_citas', 'servicios', 'establecimientos', 'pruebas'],
    data() {
        return {
            nombre: '',
            canal: '',
            dt: {
                id: 'pruebas',
                columnas: [
                    { nombre: 'Usuario', nombre_variable: 'nombre_usuario' },
                    { nombre: 'Canal', nombre_variable: 'nombre_canal' },
                    { nombre: 'Descripcion', nombre_variable: 'descripcion' },
                    { nombre: 'Destinatario', nombre_variable: 'destinatario' },
                    { nombre: 'Fecha Creacion', nombre_variable: 'created_at' },
                    { nombre: 'Fecha Procesado', nombre_variable: 'procesado_at' },
                ],
                datos: []
            },
        }
    },
    mounted() {
        // console.log(this.servicios);
        this.dt.datos = this.pruebas.map(element => {
            return {
                nombre_usuario: element.user.nombres,
                nombre_canal: element.canal.nombre,
                descripcion: element.descripcion,
                destinatario: element.destinatario,
                created_at: element.created_at,
                procesado_at: element.procesado_at,
            }
        })
    },
    methods: {
        crear() {
            this.$refs.Modal.show();
        },
        guardar() {
            this.dt.datos = [];

            axios.post('').then(response => {
                this.dt.datos = response.data.map(element => {
                    return {
                        nombre_usuario: element.user.nombres,
                        nombre_canal: element.canal.nombre,
                        descripcion: element.descripcion,
                        destinatario: element.destinatario,
                        created_at: element.created_at,
                        procesado_at: element.procesado_at,
                    }
                })
            }).catch(error => {
                location.reload();
            })
        }
    },
}
</script>
